// =========================================================
// SECTION À PROPOS — vidéo pilotée au viewport + piliers Splide en mobile.
//
// Vidéo (4,4 Mo, SOUS la ligne de flottaison) : preload="none" dans le markup,
// l'IntersectionObserver déclenche le chargement + play à l'approche (le play
// force le fetch) et met en pause hors écran (batterie/CPU). Le poster webp
// fait l'affichage immédiat. Pas d'exception reduced-motion : même politique
// que la vidéo du hero (fond d'ambiance, pas une animation UI).
//
// Piliers : Splide en MOBILE uniquement (swipe + bullets, demande Olivier) —
// mediaQuery:'min' + destroy ≥ 992px où la grille CSS 3 colonnes reprend.
// ⚠️ un splide détruit n'a pas .is-initialized → opacity:1 forcée ≥ lg dans
// le SCSS (sinon l'anti-FOUC global le masque, leçon services).
// =========================================================
import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.km-apropos').forEach((section) => {

        // ----- Rideau : épinglage en fin de course (pattern promos/hero) -----
        // top sticky = viewport - hauteur réelle (négatif : la section dépasse
        // l'écran) → son bas s'arrête au bas du viewport et la section news
        // glisse par-dessus. Recalé au resize ET au load (hauteur dépendante
        // des images/du contenu BO).
        // ⚠️ seulement si la section News la suit (rideau de l'accueil) : ailleurs, aucun épinglage.
        const isCurtain = section.nextElementSibling && section.nextElementSibling.classList.contains('km-news');
        const setPinTop = () => {
            section.style.top = Math.min(0, window.innerHeight - section.offsetHeight) + 'px';
        };
        if (isCurtain) {
            setPinTop();
            window.addEventListener('resize', setPinTop);
            window.addEventListener('load', setPinTop);
        }

        // ----- Lecture vidéo au viewport -----
        const video = section.querySelector('.km-apropos__player');
        if (video && 'IntersectionObserver' in window) {
            const io = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        video.play().catch(() => { /* autoplay refusé : le poster reste */ });
                    } else if (!video.paused) {
                        video.pause();
                    }
                });
            }, {rootMargin: '200px 0px', threshold: 0.1});
            io.observe(video);
        }

        // ----- Piliers : slider mobile -----
        const el = section.querySelector('.km-apropos__splide');
        if (el && !el.dataset.kmAproposInitialized) {
            el.dataset.kmAproposInitialized = '1';
            new Splide(el, {
                perPage: 1,
                gap: '1.5rem',
                pagination: true,
                arrows: false,
                speed: 500,
                easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
                reducedMotion: {speed: 500, rewindSpeed: 500}, // glisse conservée (politique Olivier)
                mediaQuery: 'min',
                breakpoints: {
                    992: {destroy: true}, // desktop : grille statique (CSS)
                },
            }).mount();
        }
    });

});
